export default function BulkSelectToolbar({ selectedCount, onApprove, onReject, onClear }) {
  if (selectedCount === 0) return null;
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 10,
      display: 'flex', alignItems: 'center', gap: 16,
      padding: '8px 16px', height: 48,
      background: 'rgba(255,255,255,0.97)', border: '1px solid #E2E8F0',
      borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
    }}>
      <span style={{ fontSize: 14, fontWeight: 600, color: '#0F172A', fontFamily: 'Poppins, sans-serif' }}>
        {selectedCount} selected
      </span>
      <button onClick={onApprove} style={{
        padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
        background: '#4F46E5', color: '#fff', fontSize: 14, fontWeight: 600, fontFamily: 'Poppins, sans-serif'
      }}>Approve Selected</button>
      <button onClick={onReject} style={{
        padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
        background: '#FEF2F2', color: '#F97066', fontSize: 14, fontWeight: 600, fontFamily: 'Poppins, sans-serif'
      }}>Reject Selected</button>
      <button onClick={onClear} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        fontSize: 11, color: '#94A3B8', fontFamily: 'Poppins, sans-serif'
      }}>Clear</button>
    </div>
  );
}
